// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"2c3b9104","471":"b02f53bf","619":"38be55c8","869":"90df7481"}[chunkId] + ".chunk.css";
};